import { request } from './request'
import {
  ProgressInfo
} from './mock/progress'

// 创建或更新候选人
export function createCandidateApi(data: any): Promise<any> {
  return request({
    url: '/ats-candidate/api/v1/candidate',
    method: 'POST',
    data
  })
}

// 获取候选人详情
export function getCandidateDetailApi(candidateId: string | number): Promise<any> {
  return request({
    url: `/ats-candidate/api/v1/candidate/${candidateId}`,
    method: 'GET'
  })
}

// 删除候选人
export function deleteCandidateApi(candidateId: string | number): Promise<any> {
  return request({
    url: `/ats-candidate/api/v1/candidate/${candidateId}`,
    method: 'DELETE'
  })
}

// 检查候选人在留卡是否过期或即将过期：1=已过期；2=即将过期（距今≤30天）；null=无需提醒
export function getResidenceCardExpiryCheckApi(candidateId: string | number): Promise<1 | 2 | null> {
  return request({
    url: `/ats-candidate/api/v1/candidate/${candidateId}/residence-card-expiry-check`,
    method: 'GET'
  })
}

// 查询候选人AI摘要
export function getCandidateAiSummaryApi(candidateId: string | number): Promise<any> {
  return request({
    url: `/ats-candidate/api/v1/candidate/${candidateId}/ai-summary`,
    method: 'GET'
  })
}

// 查询候选人概要信息
export function getCandidateSummaryApi(candidateId: string | number, interviewId?: string | number): Promise<any> {
  return request({
    url: `/ats-candidate/api/v1/candidate/${candidateId}/summary`,
    method: 'GET',
    params: interviewId ? { interviewId } : undefined
  })
}

// 更新候选人负责人
export function updateCandidateOwnerApi(data: { interviewId: string | number; ownerId: string | number }): Promise<any> {
  return request({
    url: '/ats-interview/api/v1/interview/owner',
    method: 'PUT',
    data
  })
}

// 更新候选人备注
export function updateCandidateRemarkApi(data: { interviewId: string | number; remark: string }): Promise<any> {
  return request({
    url: '/ats-interview/api/v1/interview/remark',
    method: 'PUT',
    data
  })
}

// 查询候选人AI评分
export function getCandidateAiEvaluationApi(candidateId: string | number, jobPostingId: string | number): Promise<any> {
  return request({
    url: `/ats-candidate/api/v1/candidate/${candidateId}/job-posting/${jobPostingId}/evaluation`,
    method: 'GET'
  })
}

// 简历筛选列表 - 分页查询候选人
export function getCandidatePageApi(data: {
  pageNum: number
  pageSize: number
  sortColumn?: string
  candidateId?: number
  candidateName?: string
  responsiblePersonId?: number
  jobId?: number
  applicationChannel?: number
  nationalityList?: string[] | number[]
  residenceTypeList?: string[] | number[]
  japaneseLevelList?: string[] | number[]
  desiredJobIndustryList?: string[] | number[]
  specialSkillIndustry1List?: string[] | number[]
  specialSkillIndustry2List?: string[] | number[]
  resumeSourceList?: string[] | number[]
  recentIndustryList?: string[] | number[]
  gender?: string
  selectionStatus?: number
  asc?: boolean
  [key: string]: any
}): Promise<any> {
  return request({
    url: '/ats-candidate/api/v1/candidate/page',
    method: 'POST',
    data
  })
}

export type InterviewStatusQuery = {
  stepType: number, 
  subType: number, 
  stepStatus: number
}
// 查询候选人面试列表 - 分页查询候选人
export function getCandidateInterviewPageApi(data: {
  pageNum: number
  pageSize: number
  sortColumn?: string
  asc?: boolean
  selectionStatus?: number
  nationalityList?: string[] | number[]
  residenceTypeList?: string[] | number[]
  japaneseLevelList?: string[] | number[]
  desiredJobIndustryList?: string[] | number[]
  specialSkillIndustry1List?: string[] | number[]
  specialSkillIndustry2List?: string[] | number[]
  resumeSourceList?: string[] | number[]
  recentIndustryList?: string[] | number[]
  interviewIdList?: string[] | number[]
  candidateIdList?: string[] | number[]
  candidateNameList?: string[] | number[]
  email?: string
  applicationDateStart?: string
  applicationDateEnd?: string
  jobIdList?: string[] | number[]
  responsiblePersonIdList?: string[] | number[]
  applicationChannelList?: string[] | number[]
  stepList?: InterviewStatusQuery[]
}): Promise<any> {
  return request({
    url: '/ats-candidate/api/v1/candidate/interview-page',
    method: 'POST',
    data
  })
}

// 上传附件通用
export function uploadAttachmentApi(
  file: File
): Promise<AttachmentInfo> {
  const formData = new FormData()
  formData.append('file', file)

  return request({
    url: `/ats-candidate/api/v1/candidate/upload`,
    method: 'POST',
    data: formData
  });
}

// 简历AI解析
export function resumeAnalysisApi(s3key: string): Promise<any> {
  return request({
    url: '/ats-candidate/api/v1/candidate/resume-analysis',
    method: 'POST',
    data: {
      s3key
    }
  })
}

// 在留卡AI解析
export function residenceCardAnalysisApi(s3key_1: string, s3key_2: string): Promise<any> {
  return request({
    url: '/ats-candidate/api/v1/candidate/residence-card-analysis',
    method: 'POST',
    data: {
      s3key_1,
      s3key_2
    }
  })
}

// 检查员工是否可以删除
export function checkCandidateCanDeleteApi(candidateId: number | string): Promise<boolean> {
  return request({
    url: `/ats-interview/api/v1/interview/candidate/${candidateId}/in-progress`,
    method: 'GET'
  })
}

// 投递职位
export function applyJobApi(data: {
  jobId: number
  candidateId: number
  reason: string
}): Promise<any> {
  return request({
    url: '/ats-interview/api/v1/interview/apply',
    method: 'POST',
    data
  })
}

// 职位投递全列表查询
export function getCandidateJobsApi(candidateId: number | string): Promise<any> {
  return request({
    url: `/ats-job/api/v1/candidate-jobs/${candidateId}`,
    method: 'GET',
  })
}

// 猎头端可投递企业下拉列表
export function getHeadhuntingEnterpriseListApi(): Promise<any> {
  return request({
    url: `/ats-job/api/v1/headhunting-job/candidate-jobs/enterprise-selector`,
    method: 'GET',
  })
}

// 猎头职位投递全列表查询
export function getHeadhuntingJobCandidateJobsApi(candidateId: number | string, enterpriseId: number | string): Promise<any> {
  return request({
    url: `/ats-job/api/v1/headhunting-job/candidate-jobs/${candidateId}/${enterpriseId}`,
    method: 'GET',
  })
}

// 批量终止选考流程
export function batchTerminateInterviewApi(data: {
  interviewIds: number[]
}): Promise<any> {
  return request({
    url: '/ats-interview/api/v1/interview/batch-terminate',
    method: 'POST',
    data
  })
}

// 投递记录请求参数
export interface ApplicationRecordsRequest {
  pageNum: number;
  pageSize: number;
  sortColumn?: string;
  candidateId?: number;
  jobId?: number;
  stepId?: number;
  stepList?: InterviewStatusQuery[];
  status?: number | string;
  asc?: boolean;
}

// 面试步骤详情
export interface InterviewStepDetail {
  id: number;
  interviewId: number;
  stepId: number;
  name: string;
  orderIndex: number;
  type: number;
  tplId: number;
  interviewerId: number;
  interviewerName: string;
  interviewType: number;
  interviewDuration: number;
  interviewStart: string;
  interviewEnd: string;
  interviewSelected: Record<string, any>;
  interviewUrl: string;
  invitationUrl: string;
  interviewLocation: string;
  interviewRemark: string;
  interviewSchedule: any[];
  evaluatedAt: string;
  evaluatedResult: number;
  evaluatedComments: string;
  joinAt: string;
  status: number;
  statusName: string;
  createBy: number;
  createTime: string;
  updateBy: number;
  updateByName: string;
  updateTime: string;
}

// 面试进度信息
export interface InterviewProgress {
  interviewId: number;
  candidateId: number;
  jobId: number;
  status: number;
  currentStep: InterviewStepDetail | null;
  steps: InterviewStepDetail[];
  updateBy: number;
  updateByName: string;
}

// 附件信息
export interface AttachmentInfo {
  name: string;
  s3key: string;
  url: string;
}

// 职位信息
export interface JobInfo {
  id: number;
  enterpriseId: number;
  title: string;
  jobType: number;
  status: string;
  appOpen: number;
  publishTime: string;
  auditTime: string;
  closeTime: string;
  auditFailedReason: string;
  appDisplayImages: AttachmentInfo[];
  otherDocuments: AttachmentInfo[];
  createBy: number;
  createTime: string;
  updateTime: string;
  affiliationId: number;
}

// 候选人信息
export interface CandidateInfo {
  id: number;
  name: string;
  nameKana: string;
  applicationChannel: number;
  enterpriseId: number;
  gender: string;
  birthday: string;
  nationality: string;
  phone: string;
  email: string;
  residenceCardAddress: string;
  nearestStation: string;
  hasSpouse: number;
  dependents: number;
  employmentStatus: number;
  desiredJobStartDate: number;
  desiredJobIndustry: number;
  selfPr: string;
  reasonForApplication: string;
  owner: number;
  remark: string;
  aiSummary: string;
  createBy: number;
  createTime: string;
  updateTime: string;
  recentIndustry: number;
}

// 投递记录详情
export interface ApplicationRecord {
  interviewId: number;
  jobId: number;
  candidateId: number;
  stepId: number;
  stepStatus: number;
  stepStatusName: string;
  applicationChannel: number;
  applicationChannelName: number;
  progress: InterviewProgress | null;
  jobInfo: JobInfo | null;
  candidateInfo: CandidateInfo | null;
  createTime: string;
  aiScore: number;
}

// 投递记录响应
export interface ApplicationRecordsResponse {
  size: number;
  total: number;
  records: ApplicationRecord[];
  current: number;
  pages: number;
}



// 查询投递记录（分页接口）
export function getApplicationRecords(params: ApplicationRecordsRequest): Promise<ApplicationRecordsResponse> {
  return request({
    url: '/ats-interview/api/v1/interview/application-records',
    method: 'POST',
    data: params
  })
}

// 面试状态统计子项
export interface InterviewStatusStat {
  stepId: number;
  status: number;
  statusName: string;
  count: number;
}

// 面试步骤统计
export interface InterviewStepStat {
  stepId: number;
  stepName: string;
  children: InterviewStatusStat[];
}



// 获取选考进度
export function getInterviewProgressApi(interviewId: string | number): Promise<any> {
  // return ProgressInfo;
  return request({
    url: '/ats-interview/api/v1/interview/progress',
    method: 'GET',
    params: { interviewId }
  })
}

// 获取分组筛选数据
export function getCandidateFilterGroupsApi(data?: any): Promise<any> {
  return request({
    url: '/ats-candidate/api/v1/candidate/filter-groups',
    method: 'POST',
    data
  })
}

// 筛选选项类型
export interface FilterOption {
  id: string | number
  name: string
}

// 候选人下拉选项模糊搜索
export function getCandidateFilterOptionsApi(
  keyword: string,
  inProgress?: number, // 标记是否从选考中的候选人中获取
  candidateIdList?: Array<string | number>
): Promise<FilterOption[]> {
  const params: Record<string, unknown> = { keyword, inProgress }
  if (candidateIdList && candidateIdList.length > 0) {
    params.candidateIdList = candidateIdList
  }
  return request({
    url: '/ats-candidate/api/v1/candidate/filter-options/candidates',
    method: 'GET',
    params
  })
}

// Meta 用户名（ユーザー名_Meta）下拉选项模糊搜索
// 返回 { id, name }：name 是展示用的 Meta 用户名，id 才是筛选提交值（userNameMetaIds）
export function getMetaUserNameFilterOptionsApi(keyword: string): Promise<FilterOption[]> {
  return request({
    url: '/ats-candidate/api/v1/candidate/filter-options/meta-usernames',
    method: 'GET',
    params: { keyword }
  })
}

// 応募求人选项类型（与 filter-groups 的 jobPositions 结构一致）
export interface JobFilterOption {
  id: string | number
  name: string
  affiliationName?: string
  positionName?: string
}

// 応募求人下拉联想搜索
export function getJobFilterOptionsApi(
  keyword: string,
  jobIdList?: Array<string | number>
): Promise<JobFilterOption[]> {
  const params: Record<string, unknown> = { keyword }
  if (jobIdList && jobIdList.length > 0) {
    params.jobIdList = jobIdList
  }
  return request({
    url: '/ats-candidate/api/v1/candidate/filter-options/jobs',
    method: 'GET',
    params
  })
}
// 获取面试日程数据
export function getInterviewScheduleApi(interviewId: string | number): Promise<any> {
  return request({
    url: '/ats-interview/api/v1/interview/schedule',
    method: 'GET',
     params: { interviewId }
  })
}

// 获取应聘信息数据
export function getInterviewApplicationInfoApi(interviewId: string | number): Promise<any> {
  return request({
    url: `/ats-interview/api/v1/interview/${interviewId}/application-info`,
    method: 'GET',
  })
}

// 提交环节评估结果（通用接口）
// status: 目标状态。传 4(已完成) 时触发状态机（首次提交评估），其他值或不传则仅更新评语等内容字段
export function submitInterviewEvaluationApi(data: {
  processId: number
  type: number
  status?: number
  result?: number
  comments?: string
  joinDate?: string
  offerLetterS3Key?: string[]
}): Promise<any> {
  return request({
    url: '/ats-interview/api/v1/interview/evaluation',
    method: 'POST',
    data
  })
}

// 终止选考流程
export function terminateInterviewApi(data: {
  interviewId: number | string
  terminateCode: number | string
  reason?: string
}): Promise<any> {
  return request({
    url: '/ats-interview/api/v1/interview/terminate',
    method: 'POST',
    data
  })
}

// 预约/调整面试
export function scheduleInterviewApi(data: {
  interviewId: number
  stepId: number
  interviewerId: number
  interviewType: number
  interviewDuration: number
  interviewSchedule?: Array<{
    date: string
    startTime: string
    endTime: string
  }>
  interviewUrl?: string
  interviewLocation?: string
  interviewRemark?: string
}): Promise<any> {
  return request({
    url: '/ats-interview/api/v1/interview/schedule',
    method: 'POST',
    data
  })
}

// 获取状态统计（按环节分组）
export function getInterviewStatusStatsApi(params?: {
  candidateId?: number | string
  jobId?: number | string
  stepType?: number | string
  [key: string]: any
}): Promise<any> {
  return request({
    url: '/ats-interview/api/v1/interview/status-stats',
    method: 'GET',
    params
  })
}

// 获取用户列表（面试官或负责人）
export function getCandidateAccountApi(params: {
  userType: 'responsible' | 'interviewer'
  roleCodesExclude?: string[]
}): Promise<any> {
  return request({
    url: '/ats-candidate/api/v1/candidate/account',
    method: 'GET',
    params
  })
}

// 创建留言（interviewId 可选：入库候选人详情页仅有 candidateId）
export function createCandidateMessageApi(data: {
  candidateId: number
  interviewId?: number
  parentId?: number
  content: string
  attachments?: Array<{
    filePath: string
    fileName: string
    mimeType: string
    size: number
  }>
  // 是否从选考页面发起（true=选考页面，false/未传=候选人页面）
  fromSelectionPage?: boolean
}): Promise<any> {
  return request({
    url: '/ats-candidate/api/v1/candidate/message',
    method: 'POST',
    data
  })
}

// 获取留言列表（基于 candidateId）
export function getCandidateMessageListByCandidateApi(candidateId: number | string): Promise<any> {
  return request({
    url: `/ats-candidate/api/v1/candidate/${candidateId}/messages`,
    method: 'GET'
  })
}

// 更新留言
export function updateCandidateMessageApi(data: {
  content: string
  messageId: number | string
}): Promise<any> {
  return request({
    url: '/ats-candidate/api/v1/candidate/message',
    method: 'PUT',
    data
  })
}

// 删除留言
export function deleteCandidateMessageApi(messageId: number | string): Promise<any> {
  return request({
    url: `/ats-candidate/api/v1/candidate/message/${messageId}`,
    method: 'DELETE'
  })
}

// 确认入职日期
export function confirmJoinDateApi(data: {
  interviewId: number
  stepId: number
  joinDate: string
  remark?: string
}): Promise<any> {
  return request({
    url: '/ats-interview/api/v1/interview/join-date/confirm',
    method: 'POST',
    data
  })
}

// 修改入职日期
export function updateJoinDateApi(data: {
  interviewId: number
  stepId: number
  joinDate: string
  remark?: string
}): Promise<any> {
  return request({
    url: '/ats-interview/api/v1/interview/join-date/update',
    method: 'PUT',
    data
  })
}

// 确认入职
export function confirmJoinApi(data: {
  interviewId: number
  stepId: number
  joined: number // 1-已入职，0-未入职
  reason?: string // 原因（未入职时必填）
  joinDate?: string // 入社日
}): Promise<any> {
  return request({
    url: '/ats-interview/api/v1/interview/join/confirm',
    method: 'POST',
    data
  })
}

// 发送内定通知书（内定通知書送付）
export function sendJobOfferApi(data: {
  interviewId: number
  stepId: number
  joinDate?: string // 入社予定日
  remark?: string // メモ欄
  offerLetterS3Key: string[] // 内定通知书 S3 Key
}): Promise<any> {
  return request({
    url: '/ats-interview/api/v1/interview/offer/send',
    method: 'POST',
    data
  })
}

// 取消面试
export function cancelInterviewApi(data: {
  processId: number
}): Promise<any> {
  return request({
    url: '/ats-interview/api/v1/interview/cancel',
    method: 'POST',
    data
  })
}

// 查询面试信息
export function getInterviewInfoApi(params: {
  interviewId: number | string
  stepId: number | string
}): Promise<any> {
  return request({
    url: '/ats-interview/api/v1/interview/info',
    method: 'GET',
    params
  })
}

// 获取附件简历S3地址
export function getCandidateResumeUrlApi(candidateId: number | string): Promise<any> {
  return request({
    url: `/ats-candidate/api/v1/candidate/${candidateId}/resume/url`,
    method: 'GET'
  })
}

// 获取在线简历S3地址
export function getCandidateOnlineResumeUrlApi(candidateId: number | string): Promise<any> {
  return request({
    url: `/ats-candidate/api/v1/candidate/${candidateId}/online-resume/url`,
    method: 'GET',
  })
}

// 获取在线简历PDF（二进制流）
export function getCandidateOnlineResumePdfApi(candidateId: number | string): Promise<Blob> {
  return request({
    url: '/ats-candidate/api/v1/resume/pdf',
    method: 'GET',
    params: { candidateId },
    responseType: 'blob'
  })
}

// 获取全部资料S3地址
export function getCandidateAllDocumentsUrlApi(candidateId: number | string): Promise<any> {
  return request({
    url: `/ats-candidate/api/v1/candidate/${candidateId}/all-documents/url`,
    method: 'GET'
  })
}

// 获取批量全部资料S3地址
export function getBatchAllDocumentsUrlApi(data: {
  candidateIds: (number | string)[]
}): Promise<any> {
  return request({
    url: '/ats-candidate/api/v1/candidate/batch-download/all-documents/url',
    method: 'POST',
    data
  })
}

// 获取批量附件简历S3地址
export function getBatchAttachmentResumesUrlApi(data: {
  candidateIds: (number | string)[]
}): Promise<any> {
  return request({
    url: '/ats-candidate/api/v1/candidate/batch-download/attachment-resumes/url',
    method: 'POST',
    data
  })
}

// 获取批量在线简历S3地址
export function getBatchOnlineResumesUrlApi(data: {
  candidateIds: (number | string)[]
}): Promise<any> {
  return request({
    url: '/ats-candidate/api/v1/candidate/batch-download/online-resumes/url',
    method: 'POST',
    data
  })
}

// 获取面试状态统计（按筛选条件）
export function getInterviewStatusStatsByFilterApi(data: any): Promise<any> {
  return request({
    url: '/ats-interview/api/v1/interview/status-stats-by-filter',
    method: 'POST',
    data
  })
}

// 获取终止状态统计（按筛选条件）
export function getTerminateStatusStatsByFilterApi(data: any): Promise<any> {
  return request({
    url: '/ats-interview/api/v1/interview/terminate-stats-by-filter',
    method: 'POST',
    data
  })
}

// 创建猎头留言
export function createRecruiterMessageApi(data: {
  interviewId: number
  content: string
  attachments?: Array<{
    filePath: string
    fileName: string
    mimeType: string
    size: number
  }>
}): Promise<any> {
  return request({
    url: '/ats-candidate/api/v1/candidate/recruiter-contact',
    method: 'POST',
    data
  })
}

// 获取猎头留言列表
export function getRecruiterMessageListApi(interviewId: number | string): Promise<any> {
  return request({
    url: `/ats-candidate/api/v1/candidate/${interviewId}/recruiter-contacts`,
    method: 'GET'
  })
}

// 更新留言
export function updateRecruiterMessageApi(data: {
  content: string
  contactId: number | string
}): Promise<any> {
  return request({
    url: '/ats-candidate/api/v1/candidate/recruiter-contact',
    method: 'PUT',
    data
  })
}

// 删除留言
export function deleteRecruiterMessageApi(contactId: number | string): Promise<any> {
  return request({
    url: `/ats-candidate/api/v1/candidate/recruiter-contact/${contactId}`,
    method: 'DELETE'
  })
}

// 标记单条社外联络的已读状态：1=已读，2=未读
export function updateRecruiterContactReadStatusApi(data: {
  contactId: number | string
  status: 1 | 2
}): Promise<any> {
  return request({
    url: '/ats-candidate/api/v1/candidate/recruiter-contact/read-status',
    method: 'PUT',
    data
  })
}

export interface CandidateStatusStatsParams {
  candidateIdList?: Array<string | number> | null
  candidateNameList?: Array<string | number> | null
  responsiblePersonIdList?: Array<string | number> | null
  jobIdList?: Array<string | number> | null
  applicationChannelList?: Array<string | number> | null
  interviewIdList?: Array<string | number> | null
  email?: string | null
  nationalityList?: Array<string | number> | null
  residenceTypeList?: Array<string | number> | null
  japaneseLevelList?: Array<string | number> | null
  recentIndustryList?: Array<string | number> | null
  desiredJobIndustryList?: Array<string | number> | null
  specialSkillIndustry1List?: Array<string | number> | null
  specialSkillIndustry2List?: Array<string | number> | null
  resumeSourceList?: Array<string | number> | null
  applicationDateStart?: string
  applicationDateEnd?: string
}

export interface CandidateStatusStatsResponse {
  resumeScreeningCount: number
  interviewCount: number
  internalDecisionCount: number
  pendingOnboardingCount: number
  onboardedCount: number
  terminatedCount: number
}

// 选考中候选人各状态数量
export function getCandidateStatusStatsApi(data: CandidateStatusStatsParams): Promise<CandidateStatusStatsResponse> {
  return request({
    url: '/ats-candidate/api/v1/candidate/interview-status-counts',
    method: 'POST',
    data
  })
}

/** 候选人状态选项 */
export interface CandidateStatusOptionItem {
  id: number
  name: string
  /** 引用次数，>0 时不支持删除 */
  refCount: number
}

/** 候选人状态选项列表 */
export function getCandidateStatusOptionsApi(): Promise<CandidateStatusOptionItem[]> {
  return request({
    url: '/ats-candidate/api/v1/candidate/status-options',
    method: 'GET'
  })
}

/** 添加候选人状态选项 */
export function createCandidateStatusOptionApi(data: { name: string }): Promise<any> {
  return request({
    url: '/ats-candidate/api/v1/candidate/status-options',
    method: 'POST',
    data
  })
}

/** 重命名候选人状态选项 */
export function renameCandidateStatusOptionApi(data: { id: number; name: string }): Promise<any> {
  return request({
    url: '/ats-candidate/api/v1/candidate/status-options',
    method: 'PUT',
    data
  })
}

/** 删除候选人状态选项 */
export function deleteCandidateStatusOptionApi(id: number | string): Promise<any> {
  return request({
    url: `/ats-candidate/api/v1/candidate/status-options/${id}`,
    method: 'DELETE'
  })
}

/** 更新候选人状态 */
export function updateCandidateStatusApi(data: { candidateId: number | string; statusId: number | null }): Promise<any> {
  return request({
    url: '/ats-candidate/api/v1/candidate/status',
    method: 'PUT',
    data
  })
}

/** 更新候选人自身的备注（自社候補者リスト 用，区别于选考中候选人的面试备注） */
export function updateCandidateProfileRemarkApi(data: { candidateId: string | number; remark: string }): Promise<any> {
  return request({
    url: '/ats-candidate/api/v1/candidate/remark',
    method: 'PUT',
    data
  })
}

/** 设置候选人状态选项的次回行動日（日期为 YYYY-MM-DD，清空时传空串） */
export function updateCandidateNextActionDateApi(data: { id: number | string; nextActionDate: string }): Promise<any> {
  return request({
    url: '/ats-candidate/api/v1/candidate/status-options/next-action-date',
    method: 'PUT',
    data
  })
}
